export function truncateFileName(name: string, maxLength = 20): string {
  return name.length > maxLength ? name.slice(0, maxLength) + '…' : name;
}
